import { shape, string, number, bool, object } from 'prop-types';

export const deviceType = shape({
  locationId: string,
  doorbotId: number,
  ownerId: number,
  type: string,
  name: string,
  metadata: object,
  stark_eligible: bool,
  stark_eligible_info: string,
  starkEnrolled: bool,
});
